export class HrHiringNeed {
    id!: string
    position!: string
    needs!: number
    applicants!: number
    interviews!: number
    offers!: number
    referrals!: number
    applicationsRejected!: number
    applicationsUnderReview!: number
    screenings!: number
}
